/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Next_Event_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Next Event" |
*
* @param {Player_Next_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_next_event_aria_label = /** @type {((inputs?: Player_Next_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Next_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Evenement Suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nächste Veranstaltung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prossimo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Следующее событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Próximo evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下一个活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次のイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगली घटना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Próximo evento")
	return /** @type {LocalizedString} */ ("Next Event")
});